export enum AuthFactor {
  First,
  Second,
}
type FirstFactorData = {
  type: AuthFactor.First;
  payload: {
    email: string;
    password: string;
    // Browser-detected IANA zone, attached web-only (see detectBrowserTimeZone). The server seeds
    // it onto users.timezone only when that column is null, so a manual choice always wins.
    time_zone?: string;
  };
};
type SecondFactorData = {
  type: AuthFactor.Second;
  payload: {
    email: string;
    password: string;
    otp_attempt: string;
    time_zone?: string;
  };
};

export type LoginData = FirstFactorData | SecondFactorData;
